import RNVeriffSdk from "@veriff/react-native-sdk";
import { createVeriffFrame, MESSAGES } from "@veriff/incontext-sdk";

const statusError = "ERROR";

const VeriffSdk: typeof RNVeriffSdk = {
    statusDone: MESSAGES.FINISHED,
    statusCanceled: MESSAGES.CANCELED,
    statusError,
    launchVeriff: async (options) => {
        return new Promise<Awaited<ReturnType<(typeof RNVeriffSdk)["launchVeriff"]>>>((resolve) => {
            createVeriffFrame({
                url: options.sessionUrl,
                lang: options.locale,
                onReload: () => {
                    window.location.reload();
                },
                onEvent: (msg) => {
                    switch (msg) {
                        case MESSAGES.FINISHED:
                            resolve({ status: MESSAGES.FINISHED, error: "" });
                            break;
                        case MESSAGES.CANCELED:
                            resolve({ status: MESSAGES.CANCELED, error: "" });
                            break;
                    }
                },
            });
        });
    },
};

export default VeriffSdk;
